import React from 'react';
import "./about.css";
import AboutImg from "../../assets/aboutBW.jpeg";
import CV from "../../assets/Example-Cv.pdf";
import Info from "./Info";
import { FaYoutube } from "react-icons/fa";

const About = () => {
  return (
    <section className="about section" id="about">
        <h2 className="section__title">عني </h2>
        <span className="section__subtitle"> معلم لغة عربية اول</span>
        <div className="about__container container grid">
            <img src="https://scontent.fcai11-1.fna.fbcdn.net/v/t1.6435-9/60904479_1500229226779922_6694913025784152064_n.jpg?_nc_cat=106&ccb=1-7&_nc_sid=7b2446&_nc_eui2=AeEs3Fp86Md8Z7dM8QaCTrAvmJIofQP2eO2Ykih9A_Z47TBFIg5UMPOU88N4pExrdOtgc7ee3KSwXz8V6mvtQ2m3&_nc_ohc=D-Hm0le006oQ7kNvgGhxv0x&_nc_ht=scontent.fcai11-1.fna&oh=00_AYB5odpUYc60uJFxnDGvlimsc_-F3NgbXzic0Twm6HNClg&oe=66ED8B03" alt="about" className="about__img" />
            <div className="about__data">
                <p className="about__description">
                معلم لغة عربية بالمملكة العربية السعودية سابقاً ، أعتز بديني ووطني ، أحب أن أظهر الوجه الصحيح للإسلام
                </p>
                <a  href="https://www.youtube.com/@Ibrahim_Hegazi" className="button button--flex">
                    إشتراك في القناة <FaYoutube className="yout"/>
                    
                </a>
            </div>
        </div>
    </section>
  );
}

export default About;